import { render, staticRenderFns } from "./dialogVerifyOtp.vue?vue&type=template&id=1881fe77"
import script from "./dialogVerifyOtp.vue?vue&type=script&lang=js"
export * from "./dialogVerifyOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports